import { memo, useEffect, useState } from 'react';

import { t } from '../../../languages';

import { Button, Collapse, Spin } from 'antd';
import moment from 'moment';
import { MAXEXERCISESECONDS } from '../../../modules/competition';
import { genCompetitionRanking, genExerciseStats } from '../../../utils';
import MyTimer from '../../Utils/time/MyTimer';
import ShowCompetitionResults from '../StudentCompetitionDetails/ShowCompetitionResults';

const { Panel } = Collapse;

// Playing -> students competing
const CompetitionStage3 = ({ lang, theCompetition, handleFinishCompetition, handleNextExercise, handleExpireTime }) => {
    const [openedExercise, setOpenedExercise] = useState(null);
    const [currentExercise, setCurrentExercise] = useState(0);
    const [remaniningExercises, setRemaniningExercises] = useState(null);
    const [showNextExerciseButton, setShowNextExerciseButton] = useState(false);

    useEffect(() => {
        // console.log('CompetitionStage3 useEffect - theCompetition:', theCompetition);

        const _currentExercise = theCompetition.currentExercise || 0;
        setCurrentExercise(_currentExercise);
        setOpenedExercise(`e${_currentExercise}`);
        const exercises = theCompetition.exercises;
        if (exercises.length > _currentExercise && _currentExercise !== 0) setRemaniningExercises(exercises.slice(_currentExercise));
        else setRemaniningExercises(null);
    }, [theCompetition.currentExercise]);


    const exercises = theCompetition.exercises;
    const numExercises = exercises.length;
    const responses = theCompetition.responses;
    const responsesKeys = responses ? Object.keys(responses) : null;
    const numResponses = responsesKeys ? responsesKeys.length : 0;
    const startedTime = theCompetition.startedTime ? moment(new Date(theCompetition.startedTime)) : null;
    const expiryTime = startedTime ? startedTime.clone().add(MAXEXERCISESECONDS, 'seconds') : null;
    const currentTime = moment();
    const fStartedTime = startedTime ? startedTime.format('YYYY-MM-DD HH:mm:ss') : 'NO time';
    const fCurrentTime = currentTime.format('YYYY-MM-DD HH:mm:ss');
    const secondsToExpire = expiryTime ? expiryTime.diff(currentTime, 'seconds') : 0;
    const isWating = secondsToExpire > 0;

    // console.log('currentTime:', fCurrentTime, 'startedTime:', fStartedTime, 'secondsToExpire:', secondsToExpire);

    const handleOpenExercise = (ex) => {
        setOpenedExercise(ex);
    }

    const _handleNextExercise = () => {
        handleNextExercise();
        setShowNextExerciseButton(false);
    }

    if (exercises && currentExercise) {
        // console.log('currentExercise:', currentExercise, 'responsesKeys:', responsesKeys, 'exercises:', exercises, 'remaniningExercises:', remaniningExercises);

        if (isWating) {
            return <section className="response-list">
                <h3 className="exercise-title">{t(lang, exercises[currentExercise - 1].label)}</h3>
                <div className='waiting'>
                    <span><MyTimer
                        expiryTimestamp={expiryTime.toDate()}
                        stopTime={false}
                        handleExpire={() => { console.log('Timer expired'); handleExpireTime() }}
                        handleStop={(t) => console.log('stopped:', t)} />
                    </span>
                    <h3 className="code">{t(lang, 'waitingresponses')}</h3>
                    <Spin size="large" className="spinner" />
                </div>
            </section>;
        } else {
            const data = genExerciseStats(responses[`e${currentExercise}`], theCompetition.participants);
            const scores = genCompetitionRanking(responses, theCompetition.participants);

            return <section className="response-list">
                <h3 className="exercise-title">{t(lang, exercises[currentExercise - 1].label)}</h3>

                <ShowCompetitionResults
                    lang={lang}
                    exercises={exercises}
                    currentExercise={currentExercise}
                    statdata={data}
                    scores={scores}
                    onFinish={() => setShowNextExerciseButton(true)}
                    screensToShow={['solution', 'stats', 'scores']}
                />

                {showNextExerciseButton ? <div className="create-class-code">
                    <br />
                    <br />
                    {numExercises > currentExercise ?
                        <Button disabled={isWating} type="primary" className="button-blue" onClick={handleNextExercise}>{t(lang, 'startNext')}</Button> :
                        <Button disabled={isWating} type="primary" className="button-blue" onClick={handleFinishCompetition}>{t(lang, 'watchpodium')}</Button>
                    }
                </div> : null}
            </section>;
        }

    } else return null;
}

export default memo(CompetitionStage3);